// import {React , useState } from 'react';
// import { Layout, Typography, Row, Col, Card, Tag, Divider, Button  , Input} from 'antd';
// import { 
//   CalendarOutlined, 
//   EyeOutlined, 
//   CommentOutlined,
//   FireOutlined,
//   BookOutlined
// } from '@ant-design/icons';
// import { useNavigate } from 'react-router-dom';
// import { motion } from 'framer-motion';
// import Header from '../components/Header';
// import Footer from '../components/Footer';
// import './BlogPage.css';
// const { Content } = Layout;
// const { Title, Paragraph, Text } = Typography;

// const blogPosts = [
//   {
//     id: 1,
//     title: "Understanding PHC Accreditation Levels",
//     excerpt: "A complete guide to the different accreditation levels set by Punjab Health Commission and what they mean for your facility.",
//     category: "Accreditation",
//     date: "May 15, 2023",
//     views: 1245,
//     comments: 18,
//     featured: true,
//     image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
//   },
//   {
//     id: 2,
//     title: "Top 5 Quality Improvement Strategies for Hospitals",
//     excerpt: "Proven methods to enhance patient care quality while preparing for PHC accreditation.",
//     category: "Quality Improvement",
//     date: "April 28, 2023",
//     views: 982,
//     comments: 12,
//     featured: false,
//     image: "https://images.unsplash.com/photo-1581056771107-24ca5f033842?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
//   },
//   {
//     id: 3,
//     title: "Documentation Requirements for PHC Accreditation",
//     excerpt: "Essential documents your healthcare facility needs to prepare for a successful accreditation process.",
//     category: "Documentation",
//     date: "April 10, 2023",
//     views: 1560,
//     comments: 24,
//     featured: false,
//     image: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
//   },
//   {
//     id: 4,
//     title: "Staff Training for PHC Compliance",
//     excerpt: "How to effectively train your healthcare staff to meet PHC standards and requirements.",
//     category: "Training",
//     date: "March 22, 2023",
//     views: 876,
//     comments: 9,
//     featured: false,
//     image: "https://images.unsplash.com/photo-1530026186672-2cd00ffc50fe?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
//   },
//   {
//     id: 5,
//     title: "Common Pitfalls in PHC Accreditation",
//     excerpt: "Learn about the most frequent mistakes healthcare facilities make during accreditation and how to avoid them.",
//     category: "Accreditation",
//     date: "March 5, 2023",
//     views: 1342,
//     comments: 21,
//     featured: true,
//     image: "https://images.unsplash.com/photo-1581595219315-a187dd40c322?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
//   },
//   {
//     id: 6,
//     title: "Infection Control Standards in PHC Guidelines",
//     excerpt: "Detailed analysis of infection control requirements in Punjab Health Commission's accreditation standards.",
//     category: "Infection Control",
//     date: "February 18, 2023",
//     views: 1103,
//     comments: 15,
//     featured: false,
//     image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
//   },
//   {
//     id: 7,
//     title: "Preparing for PHC Mock Surveys",
//     excerpt: "Step-by-step guide to getting ready for mock surveys during your accreditation process.",
//     category: "Accreditation",
//     date: "February 2, 2023",
//     views: 765,
//     comments: 8,
//     featured: false,
//     image: "https://images.unsplash.com/photo-1585435557343-3b0781a4a4b3?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
//   },
//   {
//     id: 8,
//     title: "Patient Safety Measures in PHC Standards",
//     excerpt: "How Punjab Health Commission evaluates patient safety measures in healthcare facilities.",
//     category: "Patient Safety",
//     date: "January 15, 2023",
//     views: 987,
//     comments: 13,
//     featured: false,
//     image: "https://images.unsplash.com/photo-1581056771107-24ca5f033842?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
//   },
//   {
//     id: 9,
//     title: "Medical Record Requirements for PHC",
//     excerpt: "Complete breakdown of medical record documentation standards required by PHC.",
//     category: "Documentation",
//     date: "January 3, 2023",
//     views: 1209,
//     comments: 17,
//     featured: false,
//     image: "https://images.unsplash.com/photo-1581595219315-a187dd40c322?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
//   },
//   {
//     id: 10,
//     title: "Maintaining Accreditation After Certification",
//     excerpt: "Best practices to sustain your PHC accreditation status and prepare for renewal.",
//     category: "Accreditation",
//     date: "December 12, 2022",
//     views: 1432,
//     comments: 22,
//     featured: true,
//     image: "https://images.unsplash.com/photo-1579684453423-f84349ef60b0?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
//   }
// ];


// const categories = [
//   { name: "All", count: 10 },
//   { name: "Accreditation", count: 4 },
//   { name: "Quality Improvement", count: 1 },
//   { name: "Documentation", count: 2 },
//   { name: "Training", count: 1 },
//   { name: "Infection Control", count: 1 },
//   { name: "Patient Safety", count: 1 }
// ];

// const BlogPage = () => {
//   const [selectedCategory, setSelectedCategory] = useState("All");

//   const filteredPosts = selectedCategory === "All" 
//     ? blogPosts 
//     : blogPosts.filter(post => post.category === selectedCategory);


//     const navigate = useNavigate();

//   return (
//     <Layout className="layout">
//       <Header />
//       <Content className="blog-content">
//         {/* Hero Section */}
//         <div className="blog-hero">
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8 }}
//           >
//             <Title level={1} className="hero-title">
//               <BookOutlined style={{ marginRight: 16 }} />
//               Prime Healthcare Blog
//             </Title>
//             <Paragraph className="hero-text">
//               Expert insights on PHC accreditation, healthcare quality improvement, and facility management.
//             </Paragraph>
//           </motion.div>
//         </div>

//         {/* Featured Posts */}
//         <div className="featured-section">
//           <Title level={2} className="section-title">
//             <FireOutlined style={{ marginRight: 8, color: '#ff4d4f' }} />
//             Featured Articles
//           </Title>
//           <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
//             {blogPosts.filter(post => post.featured).map(post => (
//               <Col xs={24} md={12} key={post.id}>
//                 <motion.div
//                   whileHover={{ y: -5 }}
//                   initial={{ opacity: 0, y: 20 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true }}
//                   transition={{ duration: 0.5 }}
//                 >
//                   <Card
//                     hoverable
//                     className="featured-post-card"
//                     cover={
//                       <div 
//                         className="featured-post-image" 
//                         style={{ backgroundImage: `url(${post.image})` }}
//                       />
//                     }
//                   >
//                     <Tag color="red" className="post-category">{post.category}</Tag>
//                     <Title level={3} className="post-title">{post.title}</Title>
//                     <Paragraph className="post-excerpt">{post.excerpt}</Paragraph>
//                     <div className="post-meta">
//                       <Text type="secondary"><CalendarOutlined /> {post.date}</Text>
//                       <Text type="secondary"><EyeOutlined /> {post.views} views</Text>
//                       <Text type="secondary"><CommentOutlined /> {post.comments} comments</Text>
//                     </div>
//                     <Button 
//   type="primary" 
//   className="read-more-btn"
//   onClick={() => navigate(`/article/${post.id}`)}
// >
//   Read Article
// </Button>
//                   </Card>
//                 </motion.div>
//               </Col>
//             ))}
//           </Row>
//         </div>

//         {/* Category Filter */}
//         <div className="category-section">
//           <Title level={4} className="section-subtitle">Browse by Category</Title>
//           <div className="category-tags">
//             {categories.map(category => (
//               <Tag
//                 key={category.name}
//                 className={`category-tag ${selectedCategory === category.name ? 'active' : ''}`}
//                 onClick={() => setSelectedCategory(category.name)}
//               >
//                 {category.name} <span className="category-count">({category.count})</span>
//               </Tag>
//             ))}
//           </div>
//         </div>

//         {/* All Posts */}
//         <div className="all-posts-section">
//           <Title level={2} className="section-title">Latest Articles</Title>
//           <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
//             {filteredPosts.map(post => (
//               <Col xs={24} sm={12} md={8} key={post.id}>
//                 <motion.div
//                   whileHover={{ y: -5 }}
//                   initial={{ opacity: 0, y: 20 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true }}
//                   transition={{ duration: 0.5 }}
//                 >
//                   <Card
//                     hoverable
//                     className="post-card"
//                     cover={
//                       <div 
//                         className="post-image" 
//                         style={{ backgroundImage: `url(${post.image})` }}
//                       />
//                     }
//                   >
//                     <Tag color="blue" className="post-category">{post.category}</Tag>
//                     <Title level={4} className="post-title">{post.title}</Title>
//                     <Paragraph className="post-excerpt">{post.excerpt}</Paragraph>
//                     <div className="post-meta">
//                       <Text type="secondary"><CalendarOutlined /> {post.date}</Text>
//                       <Text type="secondary"><EyeOutlined /> {post.views}</Text>
//                     </div>
//                     <Button type="link" className="read-more-link">Read More →</Button>
//                   </Card>
//                 </motion.div>
//               </Col>
//             ))}
//           </Row>
//         </div>

//         {/* Newsletter CTA */}
//         <div className="newsletter-section">
//           <Card className="newsletter-card">
//             <Row align="middle">
//               <Col xs={24} md={12}>
//                 <Title level={3} className="newsletter-title">
//                   Stay Updated with PHC News
//                 </Title>
//                 <Paragraph className="newsletter-text">
//                   Subscribe to our newsletter for the latest updates on Punjab Health Commission standards and accreditation tips.
//                 </Paragraph>
//               </Col>
//               <Col xs={24} md={12}>
//                 <div className="newsletter-form">
//                   <Input 
//                     placeholder="Your email address" 
//                     size="large" 
//                     className="newsletter-input"
//                   />
//                   <Button 
//                     type="primary" 
//                     size="large"
//                     className="subscribe-btn"
//                   >
//                     Subscribe
//                   </Button>
//                 </div>
//               </Col>
//             </Row>
//           </Card>
//         </div>
//       </Content>
//       <Footer />
//     </Layout>
//   );
// };

// export default BlogPage;
























import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout, Typography, Row, Col, Card, Tag, Divider, Button, Skeleton } from 'antd';
import { 
  CalendarOutlined, 
  EyeOutlined, 
  CommentOutlined,
  FireOutlined,
  BookOutlined
} from '@ant-design/icons';
import { motion } from 'framer-motion';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './BlogPage.css';

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const BlogPage = () => {
  const navigate = useNavigate();
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState("All");

  useEffect(() => {
    const fetchBlogPosts = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "blogPosts"));
        const posts = [];
        querySnapshot.forEach((doc) => {
          posts.push({ id: doc.id, ...doc.data() });
        });
        setBlogPosts(posts);
      } catch (error) {
        console.error("Error fetching blog posts: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogPosts();
  }, []);

  const categories = [
    { name: "All", count: blogPosts.length },
    { name: "Accreditation", count: blogPosts.filter(post => post.category === "Accreditation").length },
    { name: "Quality Improvement", count: blogPosts.filter(post => post.category === "Quality Improvement").length },
    { name: "Documentation", count: blogPosts.filter(post => post.category === "Documentation").length },
    { name: "Training", count: blogPosts.filter(post => post.category === "Training").length }
  ];

  const filteredPosts = selectedCategory === "All" 
    ? blogPosts 
    : blogPosts.filter(post => post.category === selectedCategory);

  const featuredPosts = blogPosts.filter(post => post.featured).slice(0, 2);

  if (loading) {
    return (
      <Layout className="layout">
        <Header />
        <Content className="blog-content">
          <Skeleton active paragraph={{ rows: 10 }} />
        </Content>
      </Layout>
    );
  }

  return (
    <Layout className="layout">
      <Header />
      <Content className="blog-content">
        {/* Hero Section */}
        <div className="blog-hero">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Title level={1} className="hero-title">
              <BookOutlined style={{ marginRight: 16 }} />
              Prime Healthcare Blog
            </Title>
            <Paragraph className="hero-text">
              Expert insights on PHC accreditation, healthcare quality improvement, and facility management.
            </Paragraph>
          </motion.div>
        </div>

        {/* Featured Posts */}
        {featuredPosts.length > 0 && (
          <div className="featured-section">
            <Title level={2} className="section-title">
              <FireOutlined style={{ marginRight: 8, color: '#ff4d4f' }} />
              Featured Articles
            </Title>
            <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
              {featuredPosts.map(post => (
                <Col xs={24} md={12} key={post.id}>
                  <motion.div
                    whileHover={{ y: -5 }}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                  >
                    <Card
                      hoverable
                      className="featured-post-card"
                      cover={
                        <div 
                          className="featured-post-image" 
                          style={{ backgroundImage: `url(${post.image})` }}
                        />
                      }
                      onClick={() => navigate(`/article/${post.id}`)}
                    >
                      <Tag color="red" className="post-category">{post.category}</Tag>
                      <Title level={3} className="post-title">{post.title}</Title>
                      <Paragraph className="post-excerpt">{post.excerpt}</Paragraph>
                      <div className="post-meta">
                        <Text type="secondary"><CalendarOutlined /> {post.date}</Text>
                        <Text type="secondary"><EyeOutlined /> {post.views} views</Text>
                        <Text type="secondary"><CommentOutlined /> {post.commentCount} comments</Text>
                      </div>
                    </Card>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </div>
        )}

        {/* Category Filter */}
        <div className="category-section">
          <Title level={4} className="section-subtitle">Browse by Category</Title>
          <div className="category-tags">
            {categories.map(category => (
              <Tag
                key={category.name}
                className={`category-tag ${selectedCategory === category.name ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category.name)}
              >
                {category.name} <span className="category-count">({category.count})</span>
              </Tag>
            ))}
          </div>
        </div>

        {/* All Posts */}
        <div className="all-posts-section">
          <Title level={2} className="section-title">Latest Articles</Title>
          <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
            {filteredPosts.map(post => (
              <Col xs={24} sm={12} md={8} key={post.id}>
                <motion.div
                  whileHover={{ y: -5 }}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5 }}
                >
                  <Card
                    hoverable
                    className="post-card"
                    cover={
                      <div 
                        className="post-image" 
                        style={{ backgroundImage: `url(${post.image})` }}
                      />
                    }
                    onClick={() => navigate(`/article/${post.id}`)}
                  >
                    <Tag color="blue" className="post-category">{post.category}</Tag>
                    <Title level={4} className="post-title">{post.title}</Title>
                    <Paragraph className="post-excerpt">{post.excerpt}</Paragraph>
                    <div className="post-meta">
                      <Text type="secondary"><CalendarOutlined /> {post.date}</Text>
                      <Text type="secondary"><EyeOutlined /> {post.views}</Text>
                    </div>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </div>
      </Content>
      <Footer />
    </Layout>
  );
};

export default BlogPage;